<!-- eslint-disable no-underscore-dangle -->
<template>
  <div class="device">
      <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
        <div class="device-header">
          <a-row>
            <a-col :span="24" style="text-align: right">
              <a-form-model layout="inline" @submit="getList" @submit.native.prevent>
                <a-form-model-item>
                  <station-select type="input" v-model="search.station" />
                </a-form-model-item>
                <a-form-model-item>
                  <a-select v-model="search.type" placeholder="选择状态" allowClear style="width: 120px;">
                    <a-select-option value="connected">上线</a-select-option>
                    <a-select-option value="disconnected">下线</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item>
                  <a-input v-model="search.idCode" placeholder="设备ID" allowClear></a-input>
                </a-form-model-item>
                <a-form-model-item style="margin-right:0">
                  <a-button
                    type="primary"
                    html-type="submit"
                    icon="search"
                    @click="getList"
                  >
                    查询
                  </a-button>
                </a-form-model-item>
              </a-form-model>
            </a-col>
          </a-row>
        </div>
        <a-divider />
        <a-table
          :loading="listloading"
          :columns="columns"
          :data-source="list"
          :scroll="{ x: 1200, y: $store.getters.listTableHeight }"
          :pagination="pager"
          rowKey="_id"
          @change="change"
        >
          <span slot="status" slot-scope="text">
           <a-tag color="#87d068" v-if="text == 'connected'">上线</a-tag>
           <a-tag color="red" v-else>下线</a-tag>
          </span>
        </a-table>
    </a-card>
  </div>
</template>

<script>
import {getDeviceLogs} from '../../api/device';

const columns = [
  {
    title: '站点名称',
    dataIndex: 'station.name',
    key: 'station.name',
  },
  {
    title: '设备名称',
    dataIndex: 'device.name',
    key: 'device.name',
  },
  {
    title: '设备ID',
    dataIndex: 'device.idCode',
    key: 'device.idCode',
    ellipsis: false,
  },
  {
    title: '状态',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '时间',
    dataIndex: 'ctime',
    key: 'ctime',
  },
];

export default {
  created() {
    this.getList();
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      columns,
      search: {},
      form: {
        isDataChannel: false,
      },
      list: [],
      pager: {},
      listloading: false,
      edit: false,
    };
  },
  computed: {
    rules() {
      return {};
    },
  },
  methods: {
    async getList() {
      this.listloading = true;
      const { data } = await getDeviceLogs(this.search);
      this.list = data.docs;
      this.pager = data.pager;
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    }
  },
};
</script>

<style lang="less" scoped></style>
